export const ROOT_GREEN = '#32693d'
export const ROOT_BLUE = '#1e3e5d'
export const ROOT_BURGUNDY = '#5d293a'
export const ROOT_HONEY = '#876800'
